import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ax-light-info',
  templateUrl: './light-info.component.html',
  styleUrls: ['./light-info.component.less']
})
export class LightInfoComponent implements OnInit {
  @Input()
  message: string = '';

  @Input()
  iconVisible: boolean = true;

  @Input()
  icon: string = 'fas fa-exclamation-circle';

  @Input()
  type: 'Info' | 'Default' | 'Success' = 'Default';

  canShow: boolean = true;

  @Input()
  closable: boolean = true;
  
  constructor() { }

  ngOnInit(): void {
  }

}
